import { Titles } from '@schooly/constants';

import {
  AttendanceSessionEnum,
  EligibleGroupResponse,
  GroupAggregateSortBy,
  RegisterCompositionResponse,
  RegisterGroupIdsRequest,
  RegisterGroupResponse,
  GroupAttendanceAggregateCellResponse,
  GroupAttendanceAggregateResponse,
} from '../generated/schooly-api-v2';
import type { JustificationBase } from './endpoints/attendance';
import { GroupType } from './groups';
import { StringOrNull } from './misc';
export {
  AttendanceSessionEnum,
  GroupAggregateSortBy,
  type GroupAttendanceAggregateCellResponse,
  type GroupAttendanceAggregateResponse,
};
export interface AttendanceCode {
  id: string;
  code: string;
  name: string;
  in_school: boolean;
  order: number;
  description?: string;
  is_present: boolean;
  has_push_notifications: boolean;
  has_justification: boolean;
}

export interface AttendanceRegisterBase {
  id: string;
  name?: string;
  register_date: string;
}

export interface AttendanceDetail {
  attendance_code_id: string | null;
  order: number;
  count: number;
}

export interface AttendanceRegisterGroupDetail {
  id: string;
  name: string;
  subject: StringOrNull;
  attendance_details: AttendanceDetail[];
}

export interface AttendanceRegister extends AttendanceRegisterBase {
  group_details: AttendanceRegisterGroupDetail[];
}

export type AttendanceSessionFrequency = 'am' | 'pm';

export const attendanceSessionMap: Record<AttendanceSessionFrequency, AttendanceSessionEnum> = {
  am: AttendanceSessionEnum.Am,
  pm: AttendanceSessionEnum.Pm,
};

export interface AttendanceEntryForGroup {
  relation_id: string;
  age_group_id: string;
  attendance_code_id?: StringOrNull;
  text?: StringOrNull;
  creator_relation_id?: StringOrNull;
  creator_title?: Titles | null;
  creator_given_name?: StringOrNull;
  creator_last_name?: StringOrNull;
  creator_known_as?: StringOrNull;
  justification: JustificationBase | null;
}

export interface AttendanceEntriesForDate {
  group_id: string;
  register_id: string;
  enterable: boolean;
  relations: AttendanceEntryForGroup[];
}

export { AttendanceSessionEnum as EligibleRegisterSessionEnum } from '../generated/schooly-api-v2';

export type AttendanceRegisterSessionGroupIds = Required<
  Pick<RegisterGroupIdsRequest, 'am' | 'pm'>
>;

// Re-type group_type from the generated enum (Value1/2/3) to the app enum
// (Subject/TutorGroup/NoSubject); same values, different member names.
export type EligibleRegisterGroup = Omit<EligibleGroupResponse, 'group_type'> & {
  group_type: GroupType;
};

// Sessions use AttendanceSessionEnum; the generated field is RegisterSessionEnum with the same values.
export type RegisterCompositionGroup = Omit<RegisterGroupResponse, 'group_type' | 'sessions'> & {
  group_type: GroupType;
  sessions: AttendanceSessionEnum[];
};

export type RegisterComposition = Omit<RegisterCompositionResponse, 'groups'> & {
  groups: RegisterCompositionGroup[];
};
